import { render, staticRenderFns } from "./WalletState.vue?vue&type=template&id=a00c73e8&"
import script from "./WalletState.vue?vue&type=script&lang=ts&"
export * from "./WalletState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports